// prettier-ignore
let colors = ["#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",
  "#3e95cd", "#8e5ea2","#3cba9f", "#F4A261", "#FFD166", "#84dfea", "#E86E63",  "#00B3CA", "#F0A6CA", "#70D89C",];

let labels_predefined = [
  "ALEXA",
  "Browser",
  "Mobile-iOS",
  "Mobile-Android",
  "Text",
  "Voice",
  "Bubble",
  "SUCCESS",
  "ERROR",
  "FAILED",
  "Missed",
  "Reviewed"
];
let colors_predefined = [
  "#8e5ea2",
  "#3e95cd",
  "#cd5e53",
  "#aacd86",
  "#3cba9f",
  "#E86E63",
  "#F4A261",
  "#72EAA4",
  "#E86E63",
  "#E86E63",
  "#d60013",
  "#14e81c"
];

let color_labels = [];
let color_color = [];
let color_num = 0;

export function setColor(label) {
  let color = "";
  let return_array = [];

  if (label instanceof Array) {
    for (let i = 0; i < label.length; i++) {
      color = "";
      for (let t = 0; t < labels_predefined.length; t++) {
        if (label[i] === labels_predefined[t]) {
          color = colors_predefined[t];
          break;
        }
      }

      if (color === "") {
        for (let j = 0; j < color_labels.length; j++) {
          if (label[i] === color_labels[j]) {
            color = color_color[j];
            break;
          }
        }
      }

      if (color !== "") {
        return_array.push(color);
      } else {
        if (color_num === colors.length - 1) {
          color_num = 0;
        }

        color_labels.push(label[i]);
        // color_num = color_num % colors.length;

        let new_color = colors[color_num];
        color_color.push(new_color);
        color_num++;
        return_array.push(new_color);
      }
    }
    return return_array;
  }

  for (let t = 0; t < labels_predefined.length; t++) {
    if (label === labels_predefined[t]) {
      color = colors_predefined[t];
    }
  }
  if (color === "") {
    for (let i = 0; i < color_labels.length; i++) {
      if (label === color_labels[i]) {
        color = color_color[i];
        break;
      }
    }
  }

  if (color !== "") {
    return color;
  } else {
    color_labels.push(label);
    let new_color = colors[color_num];
    color_color.push(new_color);
    color_num++;
    return new_color;
  }
}
